import React, { Fragment } from 'react';
import { Typography, Button } from '@material-ui/core';
import { StyleRules, createStyles, withStyles } from '@material-ui/core/styles';

import AppHeader from '../headers/appHeader';
import AuthService from '../../services/authService';

interface NotAuthorizedProps {
    classes?: any;
}

const styles = (): StyleRules => {
    return createStyles({
        root: {
            margin: '16px',
            textAlign: 'center'
        },
        errorMesssage: {
            paddingTop: '16px',
            paddingBottom: '16px'
        }
    });
};

const NotAuthorized: React.FC<NotAuthorizedProps> = (props: NotAuthorizedProps): JSX.Element => {
    return (
        <Fragment>
            <AppHeader renderFullHeader={true} />
            <div className={props.classes.root}>
                <h2>Authorization Error</h2>
                <Typography className={props.classes.errorMesssage}>
                    Your session may have expired or you may not be authorized for this application. Please log out and log back in.
                </Typography>
                <Button
                    variant='outlined'
                    color='primary'
                    onClick={(): void => {
                        AuthService.logout();
                    }}
                >
                    Log Out
                </Button>
            </div>
        </Fragment>
    );
};

export default withStyles(styles)(NotAuthorized);
